import { NewCustomerResponse } from "./userIdentificationInterfaces";

export const NORWEGIAN_NIN_PREFIX = "NO~";

export function getNewCustomerNin(
  customerResponse: NewCustomerResponse,
): string | undefined {
  const nin = customerResponse?.providedPersonInfo?.nin;
  return nin ? nin.replace(NORWEGIAN_NIN_PREFIX, "") : undefined;
}
